<template>
  <gmap-map
    :center="center"
    :zoom="zoom"
    :options="mapOptions"
    ref="mapRef"
    style="
          width: 100%;
          height: 100%;
          margin: 0;
          padding: 0;
          position: absolute;
          top: 0;
          z-index: -1;
        "
    @click="hideThumbnails()"
  >
    <gmap-cluster
      :zoom-on-click="true"
      :minimumClusterSize="2"
      :styles="clusterStyles"
      key="1"
    >
      <gmap-marker
        v-for="(m, index) in markers"
        :key="index"
        :position="m.location"
        ref="markers"
        :icon="getMarkerIcon(m.waterPointType)"
        :visible="m.visible"
        :clickable="true"
        @click="showThumbnail(m, index)"
      >
      </gmap-marker>
    </gmap-cluster>

    <!-- Current location marker -->
    <gmap-marker
      v-if="isGeoLocated"
      :position="myLocation"
      :icon="myLocationMarker"
    >
    </gmap-marker>
  </gmap-map>
</template>

<script>
// @ is an alias to /src
/* global google */

import axios from 'axios'
import {setupCache} from 'axios-cache-adapter'
import {gmapApi} from 'vue2-google-maps'
import {Event} from '@/main'

// Create `axios-cache-adapter` instance
const cache = setupCache({
  maxAge: 15 * 60 * 1000
})

// Create `axios` instance passing the newly created `cache.adapter`
const api = axios.create({
  adapter: cache.adapter
})

export default {
  name: 'Map',
  data() {
    return {
      center: {
        lat: 43.563939,
        lng: 10.325945
      },
      markers: [],
      markersRaw: [],
      activeMarker: {},
      activeMarkerWalkingDistance: '',
      thumbnailVisible: false,
      detailsVisible: false,
      filtersVisible: false,
      isGeoLocated: false,
      myLocation: {},
      wpTotal: 0,
      wpTotalPages: 0,
      zoom: 8,
      myLocationMarker: {
        url: require('../assets/images/current_location.svg'),
        scaledSize: {
          width: 30,
          height: 30,
          f: 'px',
          b: 'px'
        }
      },
      clusterStyles: [{
        url: require('../assets/images/marker_cluster.svg'),
        width: 40,
        height: 40,
        textSize: 11,
        textColor: 'white'
      }],
      mapOptions: {
        disableDefaultUI: true,
        scrollwheel: false,
        zoomControl: true,
        streetViewControl: false,
        minZoom: 4,
        maxZoom: 20,
        styles: [
          {
            featureType: 'administrative',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#444444'
              }
            ]
          },
          {
            featureType: 'administrative.country',
            elementType: 'geometry.fill',
            stylers: [
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'administrative.province',
            elementType: 'labels.icon',
            stylers: [
              {
                hue: '#ff0000'
              },
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'landscape',
            elementType: 'all',
            stylers: [
              {
                color: '#f2f2f2'
              }
            ]
          },
          {
            featureType: 'landscape.natural',
            elementType: 'labels.text',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'poi',
            elementType: 'all',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'all',
            stylers: [
              {
                saturation: -100
              },
              {
                lightness: 45
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'all',
            stylers: [
              {
                visibility: 'simplified'
              }
            ]
          },
          {
            featureType: 'road.arterial',
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'transit',
            elementType: 'all',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'all',
            stylers: [
              {
                color: '#46bcec'
              },
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [{color: '#515c6d'}]
          }
        ]
      }
    }
  },
  mounted() {
    // Bounds of map
    this.$refs.mapRef.$mapPromise.then((map) => {
      map.setOptions({
        zoomControlOptions: {position: this.google.maps.ControlPosition.RIGHT_BOTTOM}
      })

      // Set app locale
      this.setLocale()

      // Geolocate
      this.geoLocate()

      // Get markers
      this.getMarkers()
    })

    // We listen to the resize event
    window.addEventListener('resize', () => {
      // We execute the same script as before
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    })

    Event.$on('filterMarkers', (data) => {
      // Get a copy of all markers
      this.markers = this.markersRaw

      // filter the markers if the initial state was false (so it's true now)
      if (!data.initialState) {
        this.markers = this.markers.filter(marker => marker.waterPointType === data.type)

        // Todo: loader
      }
    })
  },
  computed: {
    google: gmapApi
  },
  methods: {

    // Get the markers from the WP API
    getMarkers() {
      api({
        url: 'https://mapdb2.refill-now.com/wp-json/wp/v2/location?per_page=100&_fields=title',
        method: 'get'
      })
        .then(async (response) => {
          this.wpTotal = response.headers['x-wp-total']
          this.wpTotalPages = response.headers['x-wp-totalpages']

          for (let i = 1; i <= this.wpTotalPages; i++) {
            const response = await api({
              url: 'https://mapdb2.refill-now.com/wp-json/wp/v2/location?per_page=100&_fields=title,x_metadata,x_featured_media&page=' + i,
              method: 'get'
            })

            const newMarkers = response.data.map(marker => {
              const meta = marker.x_metadata
              let locationData = {}
              if (parseInt(meta.location_manual_override) && typeof meta.location_google_map !== 'undefined') {
                locationData = {
                  lat: parseFloat(meta.location_google_map.lat),
                  lng: parseFloat(meta.location_google_map.lng)
                }
              } else {
                locationData = {
                  lat: parseFloat(meta.location_latitude),
                  lng: parseFloat(meta.location_longitude)
                }
              }
              return {
                title: marker.title.rendered,
                category: meta.location_category,
                waterType: meta.location_type_of_water,
                waterPointType: meta.location_type_of_water_point,
                fee: meta.location_fee,
                website: meta.location_website,
                address: meta.location_street,
                thumbnail: marker.x_featured_media || require('../assets/images/location-placeholder.png'),
                hours: meta.location_opening_hours,
                visible: true,
                location: locationData,
                locationExtra: meta.location_extra_information
              }
            })

            for (const marker in newMarkers) {
              this.markersRaw.push(newMarkers[marker])
            }

            const progress = Math.floor((i / this.wpTotal * 10000)) + '%' || '0%'
            this.$emit('loadingProgress', {progress})
          }

          this.markers = this.markersRaw = this.markersRaw.flat(3)
          const bounds = this.$refs.mapRef.$mapObject.getBounds()
          this.$refs.mapRef.$mapObject.fitBounds(bounds)

          this.$emit('hideLoading')
        })
    },

    // Set the center of the map to the geolocation
    geoLocate: function () {
      this.$refs.mapRef.$mapPromise.then((map) => {
        navigator.geolocation.getCurrentPosition(position => {
          this.myLocation = {
            lat: parseFloat(position.coords.latitude),
            lng: parseFloat(position.coords.longitude)
          }

          map.setZoom(16)
          map.panTo(this.myLocation)
          this.myLocationMarker.anchor = new google.maps.Point(15, 15)
          this.isGeoLocated = true
        })
      })
    },
    showThumbnail: function (marker, index) {
      this.activeMarker = marker
      this.$refs.mapRef.$mapPromise.then((map) => {
        map.setZoom(18)
        map.panTo({
          lat: marker.location.lat,
          lng: marker.location.lng
        })

        if (this.myLocation) {
          this.fetchDistance({
            lat: this.myLocation.lat,
            lng: this.myLocation.lng
          }, this.activeMarker.location)
            .then((result) => {
              this.activeMarkerWalkingDistance = result.rows[0].elements[0].duration.text
              const walkingDistance = this.activeMarkerWalkingDistance
              this.$emit('setWalkingDistance', {walkingDistance})
            })
        }
        this.$emit('showThumbnail', {marker, index})
      })
    },
    hideThumbnails() {
      this.$emit('hideThumbnails')
    },
    showFilters() {
      this.$emit('showFilters')
    },

    // showThumbnail: function ({ marker, index }) {
    //   this.activeMarker = marker
    //   this.$refs.mapRef.$mapPromise.then((map) => {
    //     map.setZoom(18)
    //     map.panTo({
    //       lat: marker.location.lat,
    //       lng: marker.location.lng
    //     })
    //   })
    //
    //   if (this.myLocation) {
    //     this.fetchDistance({
    //       lat: this.myLocation.lat,
    //       lng: this.myLocation.lng
    //     }, this.activeMarker.location).then((result) => {
    //       this.activeMarkerWalkingDistance = result.rows[0].elements[0].duration.text
    //
    //       this.$emit('showThumbnail', (marker, this.activeMarkerWalkingDistance))
    //     })
    //   }
    // },

    /**
     * Markericons
     */
    getMarkerIcon(type) {
      let markerUrl = require('../assets/icons/fontana-pubblica.png')

      // Public point
      if (type === 'Fontata pubblica') {
        markerUrl = require('../assets/icons/fontana-pubblica.png')
      } else if (type === 'Punto Di Acquisto') {
        // Acquiring of bottles point
        markerUrl = require('../assets/icons/punto-di-acquisto.png')
      } else if (type === 'Partner') {
        // Acquiring of bottles pointhours
        markerUrl = require('../assets/icons/partner.png')
      }
      return {
        url: markerUrl,
        scaledSize: new google.maps.Size(28, 37),
        anchor: new google.maps.Point(8, 15)
      }
    },
    setLocale() {
      const browserLocale = navigator.language.substring(0, 2)
      if (browserLocale) {
        this.$root.$i18n.locale = browserLocale
      }
    },
    async fetchDistance(origin, destination) {
      return new Promise((resolve, reject) => {
        let response
        var service = new google.maps.DistanceMatrixService()
        service.getDistanceMatrix(
          {
            origins: [origin],
            destinations: [destination],
            travelMode: 'WALKING',
            unitSystem: google.maps.UnitSystem.IMPERIAL,
            avoidHighways: false,
            avoidTolls: false
          },
          function (resp, status) {
            if (status !== google.maps.DistanceMatrixStatus.OK) {
              response = reject(status)
            } else {
              response = resolve(resp)
            }
            return response
          }
        )
        return response
      })
    }
  }
}
</script>
